import PaymentInfoBaseService from './PaymentInfoBaseService'

export default class RefundInfoService extends PaymentInfoBaseService {
  get actionPerformed(): string {
    return 'was refunded'
  }

  get paidForText(): string {
    return this.actionPerformed
  }
}
